import { useState } from 'react'
import EditorHeader from './components/EditorHeader'
import AssetsPanel from './components/AssetsPanel'
import ScriptPanel from './components/ScriptPanel'
import PreviewPanel from './components/PreviewPanel'
import TimelinePanel from './components/TimelinePanel'
import AssistantPanel from './components/AssistantPanel'
import { EditorProvider } from './contexts/EditorContext'

export default function VideoEditor() {
  const [isAssistantOpen, setIsAssistantOpen] = useState(true)
  const [isAssetsPanelOpen, setIsAssetsPanelOpen] = useState(true)
  const [isScriptPanelOpen, setIsScriptPanelOpen] = useState(true)

  return (
    <EditorProvider>
      <div className="flex h-screen flex-col overflow-hidden bg-[#F4F4F5] font-sans text-gray-900">
        {/* Header Area - with padding */}
        <div className="shrink-0 px-4 pt-4">
          <EditorHeader />
        </div>

        {/* Main Content Area - with padding/gap */}
        <div className="flex flex-1 gap-4 overflow-hidden p-4">
          {/* Left Section (Assets, Script, Preview, Timeline) */}
          <div className="flex min-w-0 flex-1 flex-col gap-4">
            {/* Top Row: Assets, Script, Preview */}
            <div className="flex min-h-0 flex-1 gap-4">
              {/* Left Sidebar - Assets */}
              {isAssetsPanelOpen && <AssetsPanel onClose={() => setIsAssetsPanelOpen(false)} />}

              {/* Middle Column - Script */}
              {isScriptPanelOpen && <ScriptPanel onClose={() => setIsScriptPanelOpen(false)} />}

              {/* Preview Panel */}
              <PreviewPanel
                isAssistantOpen={isAssistantOpen}
                onToggleAssistant={() => setIsAssistantOpen(!isAssistantOpen)}
                isAssetsPanelOpen={isAssetsPanelOpen}
                onToggleAssetsPanel={() => setIsAssetsPanelOpen(true)}
                isScriptPanelOpen={isScriptPanelOpen}
                onToggleScriptPanel={() => setIsScriptPanelOpen(true)}
              />
            </div>

            {/* Bottom Row: Timeline */}
            <div className="h-80 shrink-0">
              <TimelinePanel />
            </div>
          </div>

          {/* Right Sidebar - Assistant */}
          {isAssistantOpen && <AssistantPanel onClose={() => setIsAssistantOpen(false)} />}
        </div>
      </div>
    </EditorProvider>
  )
}
